import { fetcher } from '@commenda/utils';

export async function deleteMultipleCompliances(
  complianceIds: string[],
  nextAuthToken: string
): Promise<boolean> {
  const res = await fetcher(
    `compliance/compliances/`,
    {
      method: 'DELETE',
      body: {
        complianceIds,
      },
    },
    nextAuthToken
  );

  if (!res.ok) {
    return false;
  }

  return true;
}
